import { PageNotFound } from '@crehana/compass.ui/page-not-found';

const TemplateProductNotFoundPage = () => {
  return <PageNotFound />;
};

export default TemplateProductNotFoundPage;
